import React from 'react';
import PasswordStrengthMeter from 'components/common/form/passwordStrengthMeter';
import Error from 'components/common/form/error';
import Input from 'components/common/form/input';
import PasswordStrengthWarn from 'components/common/form/passwordStrengthWarn';
import SubmitButton from 'components/common/form/submitButton';
import FormBox from 'components/common/form/formBox';
import AutoWidthModal from 'components/common/modals/autoWidthModal';

class ChangePasswordModal extends React.PureComponent {
  render() {
    const { translate, oldPassword, newPassword, newPasswordConfirmation, passwordUpdateStatus,
            handleChange, isCapslock, toggleVisible, checkCapsLock, submitForm, errors } = this.props;
    return (
      <AutoWidthModal id="change-password-modal" headerText={translate('session.password.change')}>
        <FormBox>
          <Input
            isCapslock={isCapslock}
            subject={oldPassword}
            label={translate('session.password_reset.old_password')}
            handleChange={handleChange}
            toggleVisible={toggleVisible}
            name='oldPassword'
            checkCapsLock={checkCapsLock}
          />

          <Input
            isCapslock={isCapslock}
            subject={newPassword}
            label={translate('session.field.field_password')}
            handleChange={handleChange}
            toggleVisible={toggleVisible}
            name='newPassword'
            checkCapsLock={checkCapsLock}
          />

          <PasswordStrengthMeter
            translate={translate}
            password={newPassword.value}
          />

          <PasswordStrengthWarn translate={translate} />

          <Input
            isCapslock={isCapslock}
            subject={newPasswordConfirmation}
            label={translate('session.field.field_password_repeat')}
            handleChange={handleChange}
            toggleVisible={toggleVisible}
            name='newPasswordConfirmation'
            checkCapsLock={checkCapsLock}
          />

          {errors.map((item, index) => (
            <Error text={item} />
          ))}

          {passwordUpdateStatus === 'failure' && <Error text={translate('session.error.old_password')} />}

          <SubmitButton label={translate('session.password_reset.save')} onSubmit={submitForm} />
        </FormBox>
      </AutoWidthModal>
    )
  }
};

export default ChangePasswordModal;



// WEBPACK FOOTER //
// ./src/components/main/settings/changePasswordModal.js